<template>
    <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-bind="attrs"
                v-on="on"
                :value="formattedTime"
                @input="onTimeInput"
                @blur="onTimeBlur"
                dense
                hide-details
                flat
                type="text"
                :solo-inverted="!outlined"
                maxlength="7"
                :outlined="outlined"
            ></v-text-field>

        </template>

        <v-time-picker
            v-if="menu"
            v-model="timeValue"
            @input="onTimePickerInput"
            format="24hr"
            full-width
            scrollable
            offset-y
            style="min-width: 300px"
            class="my-custom-time-picker-class"
        ></v-time-picker>
    </v-menu>
</template>
<script>
export default {
    name: "time-input",
    props: {
        value: {
            type: String,
            default: ""
        },
        outlined: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            menu: false,
            timeValue: this.value || null
        };
    },
    computed: {
        formattedTime() {
            return this.isValidTime(this.timeValue) ? this.timeValue : "--:--";
        }
    },
    watch: {
        value(newValue) {
            this.timeValue = newValue;
        }
    },
    methods: {
        onTimeInput(value) {
            clearTimeout(this.inputTimeout);

            if (value.includes("--:--")) {
                value = value.replace(/--:--/g, "");
                this.timeValue = value;
            }

            this.inputTimeout = setTimeout(() => {
                if (!value.includes("--:--")) {
                    this.timeValue = this.autoFormatTime(value);
                    this.$emit("input", this.timeValue);
                }
            }, 1000);
        },
        onTimeBlur() {
            if (this.timeValue !== null) {
                this.timeValue = this.autoFormatTime(this.timeValue);
                this.$emit("input", this.timeValue);
                this.menu = false;
            } else {
                this.timeValue = "--:--";
            }
        },

        onTimePickerInput() {
            if (!this.isValidTime(this.timeValue)) {
                this.timeValue = "--:--";
            }
        },

        autoFormatTime(value) {
            const match = value.match(/^([01]?[0-9]|2[0-3])([0-5][0-9])?$/);

            if (match) {
                const hours = match[1] || "00";
                const minutes = match[2] || "00";
                return `${hours.padStart(2, "0")}:${minutes.padEnd(2, "0")}`;
            }

            return value;
        },
        isValidTime(time) {
            return /^([01]\d|2[0-3]):?([0-5]\d)?$/.test(time);
        }
    }
};
</script>
